import { BznavAppIds } from '@repo/common-utils';

export const SERVICE_APP_ID = (process.env.NEXT_PUBLIC_APP_ID ?? 'bznav-refund') as BznavAppIds;

export const BIZ_MESSAGE_REQUEST_TYPES = ['recollect', 'checkDecision', 'job_retention'];

export const CURRENT_LOOKUP_RESULT_TERMPLATE_VERSION = 'v-20260211';
export const CURRENT_APPLY_RESULT_TERMPLATE_VERSION = 'v-20260211';
